import apiAssegurouAuto from '../../services/apiAssegurouAuto';
import type { ManufacturerResponseDTO } from '~/dto/Insurance/manufacturerDTO';
import type { ManufacturerEntity } from '~/domain/Insurance/manufacturerEntity';
import { manufacturerResponseMapper } from '~/mappers/Insurance/manufacturerResponseMapper';

export async function getManufacturersUseCase(): Promise<ManufacturerEntity> {
  try {
    const response = await apiAssegurouAuto.get<ManufacturerResponseDTO>(
      `/auto/getFabricante/1`
    );

    return manufacturerResponseMapper(response.data);
  } catch (error) {
    return {
      success: false,
      manufacturers: [],
    };
  }
}
